// react
import React, { useEffect } from 'react';

// common
import SidebarContainer from 'common/SidebarContainer/SidebarContainer';

// 「背景」分頁的路由頁；面板內容在 components/Background（由 EditContainer 依路徑顯示）
const Background = ({ modelList, refetchModelList, netStatus, modelListIsLoading, setIsAnimation, setIsObjectTag }) => {
    useEffect(() => {
        setIsAnimation(false);
        setIsObjectTag(false);
    }, []);
    return (
        <SidebarContainer
            modelList={modelList}
            refetchModelList={refetchModelList}
            modelListIsLoading={modelListIsLoading}
            netStatus={netStatus}
        />
    );
};

export default Background;
